import type { VesselSearchHit } from '../api'

/**
 * Как назвать судно в подсказках поиска.
 *
 * В эфире (`ais_vessel.name`) имя всегда латиницей, русское приходит из
 * Регистровой книги РМРС (`ref_vessel_name_ru`) и есть у трёх четвертей флота
 * РФ. Вперёд ставим русское — его набирали, — а латиницу оставляем второй
 * строкой: по ней судно ищут в чужих системах.
 */
export function vesselLabel(v: VesselSearchHit): { primary: string; secondary: string } {
  const air = v.name?.trim() ?? ''
  const ru = v.name_ru?.trim() ?? ''
  const primary = ru || air || v.mmsi
  // Дублировать имя само под собой незачем.
  const secondary = air && air !== primary ? air : ''
  return { primary, secondary }
}
